import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Home.scss";
import MainButton from "../MainButton/MainButton";
import CompareFloorplansIcon from "../CompareFloorplansIcon/CompareFloorplansIcon";
import DragInfo from "../DragInfo/DragInfo";
import Cover from "../Cover/Cover";
import MobileFooter from "../MobileFooter/MobileFooter";
import { useRef } from "react";
import VolumeControls from "./VolumeControls.js";
import Video from "./Video.js";

const homeHeroTexture = {
    //backgroundImage: "url('/img-temp/home-hero-bg.jpg')"
};

const Home = () => {
    const content = useSelector((state) => state.content.pages.home);
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);
    const underViewport = useRef();
    const dragInfo = useRef();
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    //const muted = useState({});

    /*
    const [viewport] = useScrollBoost({
        direction: 'all',
        friction: 0.05,
        scrollMode: 'native'
    });
    */

    function hideDragInfo() {
        if (underViewport.current.scrollLeft > 40) {
            dragInfo.current.style.opacity = "0";
        } else {
            dragInfo.current.style.opacity = "1";
        }
    }

    function adjustWindowSize() {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    useEffect(() => {
        function scrollWheelTurned(e) {
            if (typeof underViewport.current != "undefined") {
                underViewport.current.scrollLeft += e.deltaY;
            }
        }

        window.addEventListener("wheel", scrollWheelTurned);
        window.addEventListener("resize", adjustWindowSize);

        return () => {
            window.removeEventListener("wheel", scrollWheelTurned);
            window.removeEventListener("resize", adjustWindowSize);
        };
    });

    if (typeof content !== "undefined") {
        var partnerStyles = [];
        if (content.intro.texture) {
            homeHeroTexture.backgroundImage = content.intro.texture;
        }

        for (var i = 0; i < content.intro.partners.length; i++) {
            var partner = content.intro.partners[i];

            var height = partner.height;
            if (
                windowSize.width >= 1024 &&
                windowSize.height >= 600 &&
                windowSize.height < 900
            ) {
                height -= 24;
            }

            var styles = {
                height: height + "px",
            };

            partnerStyles.push(styles);
        }

        return (
            <div className="home-viewport" onScroll={hideDragInfo}>
                <div
                    className={`home${isTouchScreen ? " touchscreen" : ""}`}
                    ref={underViewport}
                >
                    <Cover />
                    <DragInfo reference={dragInfo} />
                    <div
                        className="home-fullscreen hero"
                        style={homeHeroTexture}
                    >
                        {/* 
                        <img src="/img-temp/archetto-banner.png" alt="" className="mobile-banner-image" />
                        */}

                        <div className="home-hero home-content">
                            <img
                                className="home-above-logo"
                                src={content.intro.texture}
                            />
                            <img
                                className="home-above-image"
                                src={content.intro.image.url}
                            />
                            <h1 className="home-hero-title">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: content.intro.heading,
                                    }}
                                ></div>
                            </h1>
                            <div className="home-hero-tagline">
                                {content.intro.copy}
                            </div>
                            <div className="home-hero-price-wrapper">
                                <div className-="home-hero-price-above">
                                    Starting From the
                                </div>
                                <div
                                    className="home-hero-price"
                                    dangerouslySetInnerHTML={{
                                        __html: content.intro.starting_from,
                                    }}
                                />
                                {content.intro.underline_decoration &&
                                    false && (
                                        <img
                                            src={
                                                content.intro
                                                    .underline_decoration
                                            }
                                            className="underline-decoration"
                                        />
                                    )}
                            </div>
                            <div className="home-contact-us-button-container">
                                <MainButton
                                    text="CONTACT US"
                                    link="/contact-us"
                                />
                            </div>
                            {isTouchScreen && (
                                <div className="partners-container">
                                    {content.intro.partners.map(
                                        (partner, i) => (
                                            <div className="partner-logo">
                                                <img
                                                    src={partner.logo.url}
                                                    style={partnerStyles[i]}
                                                />
                                            </div>
                                        )
                                    )}
                                </div>
                            )}
                            {!isTouchScreen && (
                                <div className="partners-container">
                                    {content.intro.partners.map(
                                        (partner, i) => (
                                            <a
                                                className="partner-logo"
                                                href={partner.link}
                                                target="_blank"
                                            >
                                                <img
                                                    src={partner.logo.url}
                                                    style={partnerStyles[i]}
                                                />
                                            </a>
                                        )
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="home-fullscreen-image-container">
                            {isTouchScreen && (
                                <div className="disclaimer">
                                    The developer reserves the right to make
                                    changes and modifications to the information
                                    contained herein without prior notice.
                                    Renderings, maps and photographs are
                                    representational only and may not be
                                    accurate. Price and promotions are subject
                                    to change without notice. E.&amp;O.E.
                                </div>
                            )}

                            {content.intro.large_video && (
                                <div class="video-wrapper">
                                    <Video vidsrc={content.intro.large_video} />

                                    {!isTouchScreen &&
                                        content.intro.disclaimer && (
                                            <div className="disclaimer">
                                                {content.intro.disclaimer}
                                            </div>
                                        )}
                                </div>
                            )}
                            {!content.intro.large_video && (
                                <img
                                    src={content.intro.large_image}
                                    alt=""
                                    className="image-1"
                                />
                            )}
                        </div>
                    </div>
                    {content.use_collection_group && (
                        <div className="home-content-1 home-content">
                            <div className="container">
                                <div className="top">
                                    {content.collection.heading.top_heading}
                                </div>
                                <div className="number">
                                    {content.collection.heading.large_heading}
                                </div>
                                <div className="bottom">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: content.collection.heading
                                                .bottom_heading,
                                        }}
                                    />
                                </div>
                                <div className="copy">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: content.collection.copy,
                                        }}
                                    />
                                </div>
                                {!isTouchScreen && (
                                    <MainButton
                                        text={
                                            content.collection.link_button.text
                                        }
                                        svg={<CompareFloorplansIcon />}
                                        link={
                                            content.collection.link_button.url
                                        }
                                        external
                                        blank
                                        style={{
                                            padding: "24px 40px",
                                            width: "368px",
                                            margin: "0 auto",
                                        }}
                                    />
                                )}
                            </div>
                            <img
                                src={content.collection.large_image.url}
                                alt={content.collection.large_image.alt}
                                className="full-height-image"
                            />
                        </div>
                    )}
                    {content.use_floorplans_group && (
                        <div className="home-fullscreen home-fullscreen-alt">
                            <div className="home-content-2 home-content">
                                <h1 className="number-line">
                                    {content.floorplans.number_line}
                                </h1>
                                <h2 className="title">
                                    {content.floorplans.heading}
                                </h2>
                                <div className="copy">
                                    {content.floorplans.copy}
                                </div>

                                <MainButton
                                    link={content.floorplans.link_button.url}
                                    text={content.floorplans.link_button.text}
                                    svg={<CompareFloorplansIcon />}
                                    svgAbsolute={true}
                                    style={{
                                        padding: "24px 40px",
                                        width: "368px",
                                        margin: "0 auto",
                                    }}
                                />

                                <img
                                    src={content.floorplans.decoration}
                                    className="decoration"
                                />
                            </div>
                            <div className="home-fullscreen-image-container">
                                <img
                                    src={content.floorplans.large_image.url}
                                    alt={content.floorplans.large_image.alt}
                                    // className="full-height-image"
                                />
                            </div>
                        </div>
                    )}
                    {content.use_area_group && (
                        <div className="home-fullscreen">
                            <div className="home-content-3 home-content">
                                <h2 className="title">
                                    {content.area.heading}
                                </h2>
                                <img
                                    src={content.area.decoration}
                                    className="decoration"
                                />
                                <div className="copy">{content.area.copy}</div>
                                <MainButton
                                    link={content.area.link_button.url}
                                    text={content.area.link_button.text}
                                    style={{
                                        padding: "24px 40px",
                                    }}
                                />
                            </div>
                            <div className="home-fullscreen-image-container">
                                <img
                                    src={content.area.large_image.url}
                                    alt={content.area.large_image.alt}
                                    className="full-height-image"
                                />
                            </div>
                        </div>
                    )}
                    <MobileFooter />
                </div>
            </div>
        );
    } else {
        return <div></div>;
    }
};

export default Home;
